import React from "react";
import { Marker, APIProvider, Map } from "@vis.gl/react-google-maps";
import { ElementViewProps, MapSettings } from "@/shared/types";
import { MapStyleController } from "@/FluidPreview/Elements/Map/Components/MapStylesController";

const apiKey = "AIzaSyA9UZdAKSZyU-HkqVDIgrYk4x9TCtqN_cA";

export interface MapViewProps extends ElementViewProps {}

const MapView: React.FC<MapViewProps> = ({ element, elementSize }) => {
  const mapSettings = element?.settings as MapSettings;
  const location = {
    lat: mapSettings?.location?.lat!,
    lng: mapSettings?.location?.lng!,
  };
  const isSatellite = mapSettings?.isSatellite!;

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <APIProvider apiKey={apiKey}>
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Map
            defaultCenter={location}
            center={location}
            zoom={mapSettings?.zoom || 12}
            mapTypeControl={false}
            cameraControl={false}
            zoomControl={false}
            streetViewControl={false}
            fullscreenControl={false}
            mapTypeId={isSatellite ? "hybrid" : "roadmap"}
            scrollwheel={false}
            style={{
              width: "100%",
              height: `${elementSize?.height}px`,
            }}
          >
            <MapStyleController
              mapStyle={mapSettings?.style!}
              showLabels={mapSettings?.showLabels!}
            />
            <Marker position={location} />
          </Map>
        </a>
      </APIProvider>
    </div>
  );
};

export { MapView };
